import { render, staticRenderFns } from "./AddressSelection.vue?vue&type=template&id=70190039&"
import script from "./AddressSelection.vue?vue&type=script&lang=js&"
export * from "./AddressSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports